<template>
  <div class="ion-padding">

    <div class="result" v-if="this.allResults.length > 0">

      <ion-item
        v-for="content in allResults"
        :key="content.id"
        class="result__item"
      >
          <ion-label>

            <div style="display: flex; justify-content: space-between">
              <div>
                <h2>{{ content.title }}</h2>
              </div>
              <div>
                <div class="more-icon" slot="end">
                  <ion-icon name="ios-more" v-popover.left="{ name: 'popover' + content.id}"/>
                </div>
              </div>
            </div>

              <ion-slides pager="true">
                <ion-slide>
                  <div :id="[content.id + 'viewimage1']"></div>
                </ion-slide>
                <ion-slide>
                  <div :id="[content.id + 'viewimage2']"></div>
                </ion-slide>
                <ion-slide>
                  <div :id="[content.id + 'viewimage3']"></div>
                </ion-slide>
                <ion-slide>
                  <div :id="[content.id + 'viewimage4']"></div>
                </ion-slide>
                <ion-slide>
                  <div :id="[content.id + 'viewimage5']"></div>
                </ion-slide>
              </ion-slides>

            <div v-html="content.description" v-if="content.type != 1" class="content"/>
            <input type="hidden" :id="['testing-code-' + content.id]" :value="content.description">
            <vue-code-highlight v-if="content.type == 1" :language="content.codeType">{{ content.description }}</vue-code-highlight>

          </ion-label>

      </ion-item>
    </div>
    <div class="result" v-if="this.allResults.length === 0">
      <ion-item>
        <ion-label>Es wurden keine Inhalte gefunden.</ion-label>
      </ion-item>
    </div>

    <popover :name="'popover' + content.id" event="click"  v-for="content in allResults"
             :key="content.id">

        <a :href="['/#/content/edit/' + content.id + '/']">
          <ion-icon name="build"/>
          <label>
            Inhalt
          </label>
        </a>
        <a @click="runDeleteContent($event, content)">
          <ion-icon name="trash"/>
          <label>
            Löschen
          </label>
        </a>

    </popover>

  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import { component as VueCodeHighlight } from 'vue-code-highlight';

export default {
  name: "Results",
  components: {VueCodeHighlight},
  computed: mapGetters(["allResults"]),

  async created() {
    await this.search();

    await this.allResults.forEach(function (result) {
      const blobToImage = (blob2, viewId) => {

        return new Promise(resolve => {
          let blob = new Blob([blob2.buffer], {type: blob2.type});
          const url = URL.createObjectURL(blob);
          let img = new Image();
          img.onload = () => {
            //URL.revokeObjectURL(url);
            resolve(img);
          };
          img.src = url;
          document.getElementById(viewId).append(img);
        })
      };

      if (result.image1) {
        blobToImage(result.image1, result.id + 'viewimage1');
      } else {
        document.getElementById(result.id + 'viewimage1').remove();
      }

      if (result.image2) {
        blobToImage(result.image2, result.id + 'viewimage2');
      }else {

        document.getElementById(result.id + 'viewimage2').parentNode.remove();
      }
      if (result.image3) {
        blobToImage(result.image3, result.id + 'viewimage3');
      }else {
        document.getElementById(result.id + 'viewimage3').parentNode.remove();
      }
      if (result.image4) {
        blobToImage(result.image4, result.id + 'viewimage4');
      }else {
        document.getElementById(result.id + 'viewimage4').parentNode.remove();
      }
      if (result.image5) {
        blobToImage(result.image5, result.id + 'viewimage5');
      }else {
        document.getElementById(result.id + 'viewimage5').parentNode.remove();
      }

    });
  },
  data() {
    return {
      code: 'const A = 10',
      options: {
        theme: 'ayu-dark',
        tabSize: 4,
        mode: 'text/javascript',
        lineNumbers: true,
        line: true,
      }
    }
  },
  methods: {
    ...mapActions(["deleteContent", "setSuccessMessage", "setErrorMessage", "search"]),
    showImage(content,i){
      console.log('test' + (typeof content.image2));
      console.log('test' + (typeof content.image1));
      switch (i) {
        case 1:
          return typeof content.image1 == 'object';
        case 2:
          return typeof content.image2 == 'object';
        case 3:
          return typeof content.image3 == 'object';
        case 4:
          return typeof content.image4 == 'object';
        case 5:
          return typeof content.image5 == 'object';

        default:
          return true;
      }
    },
    copyCode (e, id) {
      e.preventDefault();
      let selector = '#testing-code-' + id;
      let testingCodeToCopy = document.querySelector(selector);

      // let doc = new DOMParser().parseFromString(testingCodeToCopy.value, 'text/html');
      //
      // testingCodeToCopy.value = doc.body.textContent || "";
      // testingCodeToCopy.setAttribute('type', 'text');
      // testingCodeToCopy.select();

      try {
        document.execCommand('copy');
        this.setSuccessMessage('Code wurde kopiert');
      } catch (err) {
        this.setErrorMessage('Ein Fehler ist aufgetreten.');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    runDeleteContent(e, content) {
      e.preventDefault();
      this.deleteContent(content);
    },

  }
};
</script>

<style scoped>
  .images {
    display: flex;
    align-items: center;
  }

  ion-icon {
    margin-left: 20px;
  }

  ion-item {
    --background: #3E4143;
    --color: #B6B6B6;
    --icon-color: #B6B6B6;
  }

  ion-list {
    --background: #3E4143;
    padding: 0;
    margin-top: 40px;
  }

  .icons {
    display: inline-flex;
    float: right;
  }


  .content {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  @media all and (display-mode: standalone), screen and (max-width: 768px) {
    .icons {
      width: 100%;
      display: block;
      float: none;
      margin-top: 20px;
      margin-bottom: 20px;
    }

    .content {
      overflow: auto;
      white-space: nowrap;
      width: 100%;
    }
  }


</style>
